import { NAV_BRAND } from '../config'
import {
  PORTAL_TYPE_FPO,
  PORTAL_TYPE_RJA,
  PORTAL_TYPE_YF
} from '../config/constants'

export const getShareText = () => {
  let text

  switch (NAV_BRAND.portal_type) {
    case PORTAL_TYPE_YF:
      text = `Traumjob im Mittelstand – gefunden auf ${NAV_BRAND.portal_name}`
      break
    case PORTAL_TYPE_RJA:
      text = `${NAV_BRAND.portal_name} - Mein Traumjob in meiner Region`
      break
    case PORTAL_TYPE_FPO:
      text = `Karriere als Fachkraft – gefunden auf ${NAV_BRAND.portal_name}`
      break
    default:
      text = ''
  }

  return text
}
